import '../stylesheets/Services.css';
import React, {useState} from 'react';
import branding from '../images/Services_branding.jpg'
import advertising from '../images/Services_advertising.jpg'
import marketing from '../images/Services_marketing.jpg'
import printing from '../images/Services_print_media.png'
import environment from '../images/Services_environmental.png'
import research from '../images/Services_research.png'
import match from '../images/match.mp4'
import unlock from '../images/unlock.mp4'
import web from '../images/Services_web_development.png'
import circle from '../images/closex.svg'
import {BrowserView, MobileView} from 'react-device-detect';

export const Services = () => {
  let index = 50;

// 1. Get all the elements into a NodeList (e.g., all list items in a specific list)
const listItems = document.querySelectorAll('button');
    console.log(listItems)

const myElement = document.getElementById('tables');
if (myElement !== null) {
    myElement.addEventListener('click', function(event) {
    // Safely access properties/methods here
    console.log("we're good!", myElement);
    // Check if the clicked element is an <li>
    if (event.target.tagName === 'BUTTON') {
        // Find the index of the clicked item within the NodeList
        index = Array.from(listItems).indexOf(event.target);
        // Log the result
        console.log('The index of the clicked item is:', index, listItems[index]);
    }
  
})};

const [stateA,setStateA]=useState(false);
console.log(stateA, listItems);
const changeStateA=()=>{
setStateA(!stateA);
}

const [stateB,setStateB]=useState(false);
console.log(stateB, listItems);
const changeStateB=()=>{
setStateB(!stateB);
}

const [stateC,setStateC]=useState(false);
console.log(stateC, listItems);
const changeStateC=()=>{
setStateC(!stateC);
}

const [stateD,setStateD]=useState(false);
console.log(stateD, listItems);
const changeStateD=()=>{
setStateD(!stateD);
}

const [stateE,setStateE]=useState(false);
console.log(stateE, listItems);
const changeStateE=()=>{
setStateE(!stateE);
}

const [stateF,setStateF]=useState(false);
console.log(stateF, listItems);
const changeStateF=()=>{
setStateF(!stateF);
}

const [stateG,setStateG]=useState(false);
console.log(stateG, listItems);
const changeStateG=()=>{
setStateG(!stateG);
}

const [stateH,setStateH]=useState(false);
console.log(stateH, listItems);
const changeStateH=()=>{
setStateH(!stateH);
}

const [stateI,setStateI]=useState(false);
console.log(stateI, listItems);
const changeStateI=()=>{
setStateI(!stateI);
}

const MyComponent = () => {
    return (
       <div> 
            <BrowserView>
            <div className='table'>
                <table id= "tables">
                <tr>
                  <td><button className= 'button' onClick={changeStateA}>Branding</button></td>
                  <td><button className= 'button' onClick={changeStateB}>Web Development</button></td>
                  <td><button className= 'button' onClick={changeStateC}>Environmental Design</button></td>
                </tr>
                <tr>
                  <td><button className= 'button' onClick={changeStateD}>Marketing</button></td>
                  <td><button className= 'button' onClick={changeStateE}>Digital Media</button></td>
                  <td><button className= 'button' onClick={changeStateF}>Market Research</button></td>
                </tr>
                <tr>
                  <td><button className= 'button' onClick={changeStateG}>Advertising</button></td>
                  <td><button className= 'button' onClick={changeStateH}>Print Media</button></td>
                  <td><button className= 'button' onClick={changeStateI}>Social Media</button></td>
                </tr>
              </table>
              {stateA ? <div className= 'modal'><div className= 'container'><img className= 'content' src= {branding}/><img onClick={changeStateA} className='close' src= {circle}/></div></div> : null}
              {stateB ? <div className= 'modal'><div className= 'container'><img className= 'content' src= {web}/><img onClick={changeStateB} className='close' src= {circle}/></div></div> : null}
              {stateC ? <div className= 'modal'><div className= 'container'><img className= 'content' src= {environment}/><img onClick={changeStateC} className='close' src= {circle}/></div></div> : null}
              {stateD ? <div className= 'modal'><div className= 'container'><img className= 'marketing' src= {marketing}/><img onClick={changeStateD} className='close' src= {circle}/></div></div> : null}
              {stateE ? <div className= 'modal'><div className= 'container'><video className= 'content' src = {unlock} width= "640" height= "480" controls>Your browser does not support the video tag.</video><img onClick={changeStateE} className='close' src= {circle}/></div></div> : null}
              {stateF ? <div className= 'modal'><div className= 'container'><img className= 'content' src= {research}/><img onClick={changeStateF} className='close' src= {circle}/></div></div> : null}
              {stateG ? <div className= 'modal'><div className= 'container'><img className= 'content' src= {advertising}/><img onClick={changeStateG} className='close' src= {circle}/></div></div> : null}
              {stateH ? <div className= 'modal'><div className= 'container'><img className= 'print' src= {printing}/><img onClick={changeStateH} className='close' src= {circle}/></div></div> : null}
              {stateI ? <div className= 'modal'><div className= 'container'><video className= 'content' src = {match} width= "640" height= "480" controls>Your browser does not support the video tag.</video><img onClick={changeStateI} className='close' src= {circle}/></div></div> : null}

            </div>
            </BrowserView>
            <MobileView>
             <div className='mobileTable'>
               <table id= "tables">
                <tr>
                  <td><button className= 'mobileButton' onClick={changeStateA}>Branding</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateB}>Web Development</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateC}>Environmental Design</button></td>
                </tr>
                <tr>
                  <td><button className= 'mobileButton' onClick={changeStateD}>Marketing</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateE}>Digital Media</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateF}>Market Research</button></td>
                </tr>
                <tr>
                  <td><button className= 'mobileButton' onClick={changeStateG}>Advertising</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateH}>Print Media</button></td>
                  <td><button className= 'mobileButton' onClick={changeStateI}>Social Media</button></td>
                </tr>
              </table>
              {stateA ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {branding}/><img onClick={changeStateA} className='mobileClose' src= {circle}/></div></div> : null}
              {stateB ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {web}/><img onClick={changeStateB} className='mobileClose' src= {circle}/></div></div> : null}
              {stateC ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {environment}/><img onClick={changeStateC} className='mobileClose' src= {circle}/></div></div> : null}
              {stateD ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {marketing}/><img onClick={changeStateD} className='mobileClose' src= {circle}/></div></div> : null}
              {stateE ? <div className= 'mobileModal'><div className= 'mobileContainer'><video className= 'mobileContent' src = {unlock} width= "640" height= "480" controls>Your browser does not support the video tag.</video><img onClick={changeStateE} className='mobileClose' src= {circle}/></div></div> : null}
              {stateF ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {research}/><img onClick={changeStateF} className='mobileClose' src= {circle}/></div></div> : null}
              {stateG ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {advertising}/><img onClick={changeStateG} className='mobileClose' src= {circle}/></div></div> : null}
              {stateH ? <div className= 'mobileModal'><div className= 'mobileContainer'><img className= 'mobileContent' src= {printing}/><img onClick={changeStateH} className='mobileClose' src= {circle}/></div></div> : null}
              {stateI ? <div className= 'mobileModal'><div className= 'mobileContainer'><video className= 'mobileContent' src = {match} width= "640" height= "480" controls>Your browser does not support the video tag.</video><img onClick={changeStateI} className='mobileClose' src= {circle}/></div></div> : null}
            </div>
            </MobileView>
        </div>
    );
};
  return (
     <div className= "body"> 
      <h2 className="subhead" id="first">Services</h2>
      <MyComponent/>
    </div>
  )
}
